import transitionPath from 'router5-transition-path'
import { findRoutes }  from '../utils'
import {
  MiddlewareFactory,
} from '../../../types/frontend/router'

import {
  AppRoute,
} from '../../../types/frontend/router'

import {
  RootState,
} from '../../../types/frontend/store_generic'

function LogMiddlewareFactory<RootStateType extends RootState = RootState>() {
  // log each route transition in development
  const logRoute: MiddlewareFactory<RootStateType> = (routes) => (router, dependencies) => (toState, fromState, done) => {
    const { toActivate } = transitionPath(toState, fromState)
    const activeRoutes = findRoutes(routes as AppRoute<RootState>[], toActivate)
    if(process.env.NODE_ENV == 'development') {
      console.log(`route:`, activeRoutes)
    } else {
      const w = window as any
      if(w && w.gtag) {
        w.gtag('event', 'page_view', {
          'page_title': activeRoutes.map(r => r.name).join('.'),
        })
      }
    }
    return done()
  }

  return logRoute
}

export default LogMiddlewareFactory